var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home data-panel-home"},[_c('Layout',{attrs:{"type":"HOME","pageTitle":_vm.$t('pageTitle'),"titleSrc":"/menu/homeIcon_black.png"}},[_c('Annouce'),_c('BonusCode',{attrs:{"status":_vm.inviteCodeStatus}}),_c('FAQ',{attrs:{"FAQ":_vm.HOME_FAQ}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }